<template>
    <div class="page-content header-clear-medium">

        <div class="card card-style">
            <div class="card-body text-center">
                <div class="tabs tabs-box mb-3" id="tab-mode-quran">
                    <div class="tab-controls rounded-s border-highlight">
                        <a @click.prevent="setActive('quran')" :aria-expanded="isActive('quran')" class="font-13 color-highlight" href="#">TAMPILAN QURAN</a>
                        <a @click.prevent="setActive('ayat')" :aria-expanded="isActive('ayat')" class="font-13 color-highlight" href="#">PER AYAT</a>
                        <a @click.prevent="setActive('kata')" :aria-expanded="isActive('kata')" class="font-13 color-highlight" href="#">PER KATA</a>
                    </div>
                </div>
                <div class="collapse" :class="{ 'show': isActive('quran') }">
                    <h2>Quran</h2>
                    <input class="mt-3 form-control w-50 mx-auto" placeholder="Pencarian" v-model="search">
                </div>
            </div>

            <div class="card card-style">
                <div class="card-body">
                    <div class="collapse" :class="{ 'show': isActive('quran') }">
                        <div class="content mb-0">
                            <h6 class="text-uppercase mt-n2">Daftar Surat</h6>
                            <div class="list-group list-custom list-group-m list-group-flush rounded-xs check-visited">
                                <router-link v-for="item in surahs" :key="item.id" class="list-group-item" :to="{ name: 'quran.detail', params: {
                                    id: item.id,
                                    title: item.name
                                } }">
                                    <i class="has-bg rounded-s bi gradient-highlight">{{ item.no }}</i>
                                    <div>{{ item.name }} <span>({{ item.ayat_count }} ayat)</span> </div>
                                    <i class="bi bi-chevron-right"></i>
                                </router-link>
                            </div>
                        </div>
    
                        <div v-if="next_page_url" class="text-center mb-2">
                            <button @click="loadMoreSurah()" class="btn gradient-highlight">Load More</button>
                        </div>
                    </div>
                    <div class="collapse" :class="{ 'show': isActive('ayat') }">
                        <div class="flex-wrap" dir="rtl">
                            <div v-for="items in show_per_ayat.data" :key="items.id">
                                <span class="arab" style="padding: 2px;" v-for="kata in items.kata" :key="kata.id" :class="{ 'text-orange': kata.count_order == 1}">{{ kata.arab_harokat }} </span>
                                <span class="border border-dark p-1 px-2 mx-2" style="font-size: 13px !important;">{{ items.no }}</span>
                                <span>({{ items.surat.name }})</span>
                            </div>
                        </div>

                        <ul class="pagination mb-0 mt-4">
                            <template v-for="(link, key) in show_per_ayat.links" >
                                <li class="page-item" :key="key" :class="{disabled: link.url === null, 'active': link.active}">
                                    <a href="javascript:void(0)" v-html="link.label" class="page-link" @click="getShowPagination(1, link.url)"/>
                                </li>
                            </template>
                        </ul>
                    </div>
                    <div class="collapse" :class="{ 'show': isActive('kata') }">
                        <div class="flex-wrap" dir="rtl" v-show="false">
                            <p class="flex-wrap mb-2">
                                <template v-for="(kata, key) in show_per_kata.data">
                                    <span :key="`${key}-1`" class="arab" style="padding: 2px;">{{ kata.arab_harokat }}</span>
                                    <!-- <span :key="`${key}-2`" class="border border-dark p-1 px-2 mx-2" style="font-size: 13px !important;">{{ kata.ayat.surat.arab }}</span> -->
                                </template>
                            </p>
                        </div>

                       <div v-for="kata in show_per_kata.data" :key="kata.id" >
                            <div class="col-lg-12 col-md-12 col-sm-12">
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <div class="float-left">
                                            <span class="border border-dark p-1 px-2 mx-2" style="font-size: 13px !important;">{{ kata.ayat.no }}</span>
                                            <span>({{ kata.ayat.surat.name }})</span>
                                        </div>
                                    </div>

                                    <div dir="rtl" class="col-lg-6 col-md-6 col-sm-6">
                                        <div class="badge bg-arab float-right m-1">
                                        <span class="text-right text-dark alert alert-danger arab_count" v-if="kata.count_order == 1">{{ kata.count }}</span>
                                        <h1 class="arab text-dark" :class="{ 'arab-first': kata.count_order == 1}" v-if="harokat">{{ kata.arab_harokat }}</h1>
                                        <h1 class="arab" v-if="!harokat">{{ kata.arab }}</h1>
                                        <!-- <div v-html="kata.basic_word"></div> -->
                                        <p class="text-black-50 text-terjemahan teksTerjemah" v-html="kata.indonesia"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <ul class="pagination mb-0 mt-4">
                            <template v-for="(link, key) in show_per_kata.links" >
                                <li class="page-item" :key="key" :class="{disabled: link.url === null, 'active': link.active}">
                                    <a href="javascript:void(0)" v-html="link.label" class="page-link" @click="getShowPagination(2, link.url)"/>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: 'Home',
    data() {
        return {
            search: '',
            isBusy: false,
            activeTab: 'quran',
            pageAyat: 1,
        }
    },
    created() {
        this.getSurah()
        this.getPerAyat();
        this.getPerKata();
    },
    methods: {
        ...mapActions('quran', ['getSurah', 'getSurahLoadMore', 'getPerAyat', 'getPerKata']),
        loadMoreSurah() {
            let next_page = parseInt(this.page) + 1
            this.getSurahLoadMore(next_page)
        },
        setActive (menuItem) {
            this.activeTab = menuItem;
        },
        isActive (menuItem) {
            return this.activeTab === menuItem;
        },
        getShowPagination(type, urlPage) {
            let split = urlPage.split('=');
            let page = split[1];
            if(type == 1) {
                this.getPerAyat(page);
            } else {
                this.getPerKata(page);
            }
        },
        setPage(currentPage, type, status) {
            if(status) {
                if (type == "next"){
                    this.pageAyat = currentPage + 1;
                    this.getPerAyat(this.pageAyat);
                } else {
                    this.pageAyat = currentPage - 1;
                    this.getPerAyat(this.pageAyat);
                }
            }
        }
    },
    watch: {
        search(value) {
            if(this.surahs) {
                if(this.isBusy == false) {
                    this.isBusy = true
                    this.getSurah(value)
                        .then(() => {
                            this.isBusy = false
                        })
                }
            }
        }
    },
    computed: {
        ...mapState('quran', {
            surahs: state => state.surahs,
            page: state => state.page,
            next_page_url: state => state.next_page_url,
            show_per_ayat: state => state.show_per_ayat,
            show_per_kata: state => state.show_per_kata
        }),
        ...mapState([
            'terjemahan_bait', 'terjemahan_kata', 'harokat', 'detail'
        ])
    }
}
</script>

<style scoped>
.arab_count {
    padding : 1px;
    /* margin-bottom: 10px; */
}</style>
